import { axiosGet } from "../../Helpers";

export const loadFAQCategories = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("faqCategory/listFaqCategory");
  setLoading(false);
  const data = response.data?.data;
  data.map((item, index) => {
    item.id = index + 1;
  });
  return data;
};
